import { createBrowserHistory } from 'history'

import { store } from '../redux/store'
import { setCartoonifyImage, setError } from '../redux/slices/userSlice'
import { b64toBlob } from './base64'
import { paramsToQuery } from './historyDecorators'

const history = createBrowserHistory()

const applyCartoonifyFilter = (file, user_id) => {
	const headers = {
		'x-rapidapi-host': 'toonify.p.rapidapi.com',
		'x-rapidapi-key': process.env.REACT_APP_X_RAPIDAPI_KEY,
	}

	const formdata = new FormData()
	formdata.append('image', file, file.name)

	const requestOptions = {
		method: 'POST',
		headers: headers,
		body: formdata,
		redirect: 'follow',
	}

	fetch(
		'https://toonify.p.rapidapi.com/v0/comic?proceed_without_face=false&return_aligned=false',
		requestOptions,
	)
		.then(response => response.json())
		.then(result => {
			if (result?.detail) {
				store.dispatch(setError({ error: result.detail }))
				history.push({
					pathname: '/error',
					state: { flow: 'cartoonify' },
					search: paramsToQuery({ user_id, external_id: user_id }),
				})
				history.go()
			} else {
				const blob = b64toBlob(result.b64_encoded_output, file.type)
				const blobUrl = URL.createObjectURL(blob)
				store.dispatch(setCartoonifyImage({ imageURL: blobUrl }))
			}
		})
		.catch(error => console.error(error))
}

export { applyCartoonifyFilter }
